import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home1',
      component: () => import( /* webpackChunkName: "home" */ '../page/Home/index.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import( /* webpackChunkName: "home" */ '../page/Home/index.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import( /* webpackChunkName: "dashboard" */ '../page/Dashboard/index.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import( /* webpackChunkName: "news" */ '../page/News/index.vue')
    },
    {
      path: '/news/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/News/details.vue')
    },
    {
      path: '/build',
      name: 'build',
      component: () => import( /* webpackChunkName: "build" */ '../page/Build/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "login" */ '../page/Login/index.vue')
    },
    {
      path: '/ecosphere',
      name: 'ecosphere',
      component: () => import( /* webpackChunkName: "ecosphere" */ '../page/Ecosphere/index.vue')
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import( /* webpackChunkName: "policy" */ '../page/Policy/index.vue')
    },
    {
      path: '/policy/details',
      name: 'policyDetails',
      component: () => import( /* webpackChunkName: "policyDetails" */ '../page/Policy/details.vue')
    },
    {
      path: '/inspectionService',
      name: 'inspectionService',
      component: () => import( /* webpackChunkName: "inspectionService" */ '../page/InspectionService/index.vue')
    },
    {
      path: '/inspectionService/details',
      name: 'inspectionServiceDetails',
      component: () => import( /* webpackChunkName: "inspectionServiceDetails" */ '../page/InspectionService/details.vue')
    },
    {
      path: '/runwayShow',
      name: 'runwayShow',
      component: () => import( /* webpackChunkName: "runwayShow" */ '../page/RunwayShow/index.vue')
    },
    {
      path: '/runwayShow/details',
      name: 'runwayShowDetails',
      component: () => import( /* webpackChunkName: "runwayShowDetails" */ '../page/RunwayShow/details.vue')
    },
    {
      path: '/video',
      name: 'video',
      component: () => import( /* webpackChunkName: "video" */ '../page/Video/index.vue')
    },
    {
      path: '/video/details',
      name: 'videoDetails',
      component: () => import( /* webpackChunkName: "videoDetails" */ '../page/Video/details.vue')
    },
    {
      path: '/intellect',
      name: 'intellect',
      component: () => import( /* webpackChunkName: "intellect" */ '../page/Intellect/index.vue')
    },
    {
      path: '/intellect/details',
      name: 'intellectDetails',
      component: () => import( /* webpackChunkName: "intellectDetails" */ '../page/Intellect/details.vue')
    },
    {
      path: '/productCenter',
      name: 'productCenter',
      component: () => import( /* webpackChunkName: "ProductCenter" */ '../page/ProductCenter/index.vue')
    },
    {
      path: '/productCenter/details/:id',
      name: 'detailsByid',
      component: () => import( /* webpackChunkName: "details" */ '../page/ProductCenter/details.vue')
    },
    {
      path: '/productCenter/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/ProductCenter/details.vue')
    },
    {
      path: '/share',
      name: 'share',
      component: () => import( /* webpackChunkName: "share" */ '../page/ProductCenter/share.vue')
    },
    {
      path: '/demand',
      name: 'demand',
      component: () => import( /* webpackChunkName: "Demand" */ '../page/Demand/index.vue')
    },
    {
      path: '/demand/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/Demand/details.vue')
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import( /* webpackChunkName: "Recruit" */ '../page/Recruit/index.vue')
    },
    {
      path: '/recruit/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/Recruit/details.vue')
    },
    {
      path: '/designer',
      name: 'designer',
      component: () => import( /* webpackChunkName: "Designer" */ '../page/Designer/index.vue')
    },
    {
      path: '/designer/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/Designer/details.vue')
    },
    {
      path: '/expert',
      name: 'expert',
      component: () => import( /* webpackChunkName: "Expert" */ '../page/Expert/index.vue')
    },
    {
      path: '/expert/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/Expert/details.vue')
    },
    {
      path: '/cooperate',
      name: 'cooperate',
      component: () => import( /* webpackChunkName: "Cooperate" */ '../page/Cooperate/index.vue')
    },
    {
      path: '/cooperate/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/Cooperate/details.vue')
    },
    {
      path: '/otherResources',
      name: 'otherResources',
      component: () => import( /* webpackChunkName: "OtherResources" */ '../page/OtherResources/index.vue')
    },
    {
      path: '/otherResources/details',
      name: 'details',
      component: () => import( /* webpackChunkName: "details" */ '../page/OtherResources/details.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import( /* webpackChunkName: "About" */ '../page/About/index.vue')
    },
    {
      path: '/404',
      name: '404',
      component: (resolve) => require(['@/page/error/404.vue'], resolve)
    },
    {
      path: '/:companyCode(\\w+)',
      name: 'CompanyIndex',
      // component: () => import( /* webpackChunkName: "details" */ '../page/Website/index.vue')
      component: (resolve) => require(['@/page/www/index.vue'], resolve)
    }
  ],
  // 控制滚动行为
  scrollBehavior() {
    return {x: 0, y: 0}
  }
})





// WEBPACK FOOTER //
// ./src/router/index.js